import { html as e, when as i } from "@microsoft/fast-element";
const r = e`
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="path-1-inside-1_6013_3082" fill="white">
      <rect x="2" y="9.98182" width="5.23636" height="10.4727" rx="0.872727" />
    </mask>
    <rect
      x="2"
      y="9.98182"
      width="5.23636"
      height="10.4727"
      rx="0.872727"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="3.49091"
      mask="url(#path-1-inside-1_6013_3082)"
    />
    <mask id="path-2-inside-2_6013_3082" fill="white">
      <rect
        x="8.98181"
        y="6.49091"
        width="5.23636"
        height="13.9636"
        rx="0.872727"
      />
    </mask>
    <rect
      x="8.98181"
      y="6.49091"
      width="5.23636"
      height="13.9636"
      rx="0.872727"
      stroke="currentColor"
      stroke-width="3.49091"
      mask="url(#path-2-inside-2_6013_3082)"
    />
    <mask id="path-3-inside-3_6013_3082" fill="white">
      <rect x="15.9636" y="3" width="5.23636" height="17.4545" rx="0.872727" />
    </mask>
    <rect
      x="15.9636"
      y="3"
      width="5.23636"
      height="17.4545"
      rx="0.872727"
      stroke="currentColor"
      stroke-width="3.49091"
      mask="url(#path-3-inside-3_6013_3082)"
    />
  </svg>
`, h = r, s = e`
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="path-1-inside-1_5493_45184" fill="white">
      <rect x="3" y="9" width="3.75" height="7.5" rx="0.625" />
    </mask>
    <rect
      x="3"
      y="9"
      width="3.75"
      height="7.5"
      rx="0.625"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="2.5"
      mask="url(#path-1-inside-1_5493_45184)"
    />
    <mask id="path-2-inside-2_5493_45184" fill="white">
      <rect x="8" y="6.5" width="3.75" height="10" rx="0.625" />
    </mask>
    <rect
      x="8"
      y="6.5"
      width="3.75"
      height="10"
      rx="0.625"
      stroke="currentColor"
      stroke-width="2.5"
      mask="url(#path-2-inside-2_5493_45184)"
    />
    <mask id="path-3-inside-3_5493_45184" fill="white">
      <rect x="13" y="4" width="3.75" height="12.5" rx="0.625" />
    </mask>
    <rect
      x="13"
      y="4"
      width="3.75"
      height="12.5"
      rx="0.625"
      stroke="currentColor"
      stroke-width="2.5"
      mask="url(#path-3-inside-3_5493_45184)"
    />
  </svg>
`, l = e`
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="path-1-inside-1_5493_45186" fill="white">
      <rect x="2" y="7" width="3" height="6" rx="0.5" />
    </mask>
    <rect
      x="2"
      y="7"
      width="3"
      height="6"
      rx="0.5"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="2"
      mask="url(#path-1-inside-1_5493_45186)"
    />
    <mask id="path-2-inside-2_5493_45186" fill="white">
      <rect x="6" y="5" width="3" height="8" rx="0.5" />
    </mask>
    <rect
      x="6"
      y="5"
      width="3"
      height="8"
      rx="0.5"
      stroke="currentColor"
      stroke-width="2"
      mask="url(#path-2-inside-2_5493_45186)"
    />
    <mask id="path-3-inside-3_5493_45186" fill="white">
      <rect x="10" y="3" width="3" height="10" rx="0.5" />
    </mask>
    <rect
      x="10"
      y="3"
      width="3"
      height="10"
      rx="0.5"
      stroke="currentColor"
      stroke-width="2"
      mask="url(#path-3-inside-3_5493_45186)"
    />
  </svg>
`, d = e`
  ${i((t) => t._type === "outline", h)}
  ${i((t) => t._type === "solid", r)}
  ${i((t) => t._type === "mini", s)}
  ${i((t) => t._type === "micro", l)}
`;
export {
  d as level1Template
};
